
import { useState } from "react";
import UserDetailCard from "../../components/UserDetailCard";
import AdminActions from "../../components/AdminActions"
import UserProgressBarDetail from "../../components/UserProgressBarDetail"
import { performanceData, milestones,applicationTableHeaders, applications ,  applicationUsageBarGraph, } from "../../components/UserManagementData";
import ClassPerformanceChart from "../../components/ClassPerformanceChart";
import MilestoneCompletion from '../../components/MilestoneCompletion';
import StudentApplicationTable from "../../components/StudentApplicationTable";
import UsageStatistics from '../../components/UsageStatistics';



function UserMangenetStudent() {
    const [reportVisibility, setReportVisibility] = useState(true);
    const [piiSafe, setPiiSafe] = useState(true);

    return (
        <>


            <div className="my-5">
                <div className="grid grid-cols-12 gap-6">
                    {/* Left column (col-4) */}
                    <div className="col-span-12 md:col-span-4 space-y-4">
                        <div>
                            <UserDetailCard role="Student" />

                        </div>
                        <div>
                            <AdminActions showGenerateReports />
                        </div>
                    </div>

                    {/* Right column (col-8) */}
                    <div className="col-span-12 md:col-span-8">
                        {/* Add your content here */}
                        <div className="card mb-4">
                            <div className="card-body p-4">
                                <div className=" ">
                                    <h2 className="text-lg font-semibold text-[#717576] ">
                                        <span className="text-lg font-bold">Performance Trend </span>
                                    </h2>
                                    <div>
                                        <ClassPerformanceChart data={performanceData} />
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="card mb-4">
                            <div className="card-body">
                                <div className="grid grid-cols-2 gap-6">

                                    <div>
                                        <MilestoneCompletion milestones={milestones} />
                                    </div>

                                    <div>
                                           <UsageStatistics applicationUsageBarGraph={applicationUsageBarGraph} />
                                    </div>

                                </div>

                            </div>
                        </div>

                           <div className="card mb-4">
                            <div className="card-body">
                                    <div>
                                        <StudentApplicationTable applications={applications} headers={applicationTableHeaders} />
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


        </>



    )
}

export default UserMangenetStudent